import React from 'react';
import AuthProvider from 'components/AuthProvider/AuthProvider';
import {QueryClient, QueryClientProvider} from 'react-query';
import ReactNotification from 'react-notifications-component';
import {ReactQueryDevtools} from 'react-query/devtools';
import Router from './Router/Router';

import 'react-notifications-component/dist/theme.css';

export const queryClient = new QueryClient();
export const WSSBase = process.env.REACT_APP_WS_URL || '';

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      <ReactNotification />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default App;
